import { useEffect, useState } from 'react';

/** Same breakpoint as the CSS: below it the app shows the phone layout. */
export const PHONE_QUERY = '(max-width: 800px)';

export function useMedia(query: string): boolean {
  const [match, setMatch] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = () => setMatch(m.matches);
    on();
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, [query]);
  return match;
}

export const useIsPhone = () => useMedia(PHONE_QUERY);
